import { defineComponent as _defineComponent } from 'vue';
import { ErrorStateAction, ErrorStateTitle } from '@/types/enums/empty-state';
import { computed } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'error-state',
  props: {
    title: {
      default: ErrorStateTitle.SOMETHING_WENT_WRONG
    },
    actionText: {
      default: ErrorStateAction.RELOAD_PAGE
    },
    actionLink: {
      default: undefined
    },
    actionLinkTarget: {
      default: '_blank'
    },
    actionLogo: {
      default: undefined
    },
    showLogo: {
      type: Boolean,
      default: true
    }
  },
  emits: ['action-clicked'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const performAction = () => {
      if (props.actionLink) {
        window.open(props.actionLink, props.actionLinkTarget);
      } else if (props.actionText === ErrorStateAction.RELOAD_PAGE) {
        window.location.reload();
      } else {
        emit('action-clicked');
      }
    };
    const logo = computed(() => props.actionLogo || require('@/assets/error-state/warning.png'));
    return {
      __sfc: true,
      props,
      emit,
      performAction,
      logo
    };
  }
});